// /src/ui/components/Toasts.tsx

import React from 'react';
import clsx from 'clsx';
import { useModelStore } from '@/store/modelStore';

export default function Toasts() {
  const toasts = useModelStore((s) => s.toasts);
  return (
    <div className="toast">
      {toasts.map((t) => (
        <div key={t.id} className="toastItem">
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span className={clsx('statusDot', t.kind ?? 'info')} />
            <b>{t.title}</b>
          </div>
          {t.detail && <div className="small">{t.detail}</div>}
        </div>
      ))}
    </div>
  );
}
